import { Button, Popover } from "antd";
import { LockOutlined, UnlockOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

interface ButtonProps {
    onClick: any;
    iconStyle?: any;
    disabled?: boolean;
    isClosed: boolean;
}

const LockButton = ({ onClick, iconStyle, disabled, isClosed }: ButtonProps) => {
    const [t] = useTranslation("common");
    const lockColor = disabled ? "gray" : "#212121";
    const content = <div>{isClosed ? t("closed") : t("open")}</div>;

    const handleButtonClick = () => {
        onClick();
    };

    return (
        <>
            <Popover content={content} mouseEnterDelay={0} mouseLeaveDelay={0}>
                <Button
                    disabled={disabled}
                    className="Button"
                    type="text"
                    icon={
                        isClosed ? (
                            <LockOutlined style={{ color: lockColor, fontSize: "14px", ...iconStyle }} />
                        ) : (
                            <UnlockOutlined style={{ color: lockColor, fontSize: "14px", ...iconStyle }} />
                        )
                    }
                    onClick={handleButtonClick}
                    size="small"
                />
            </Popover>
        </>
    );
};

export default LockButton;
